import React, {useEffect, useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Editor from "../../common/Editor";
import {MODE_CREATE, MODE_EDIT} from "../../codes";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import useToast from "../../util/useToast";
import {apiCreateFolder, apiUpdateFolder} from "../../api/ApiFolders";
import {FolderErrors} from "../../errors/ErrorsMapping";

const FolderEditor = ({show, mode, hide, folder = {}}) => {
  const {showToastSuccess} = useToast();

  const queryClient = useQueryClient();

  const nameRef = useRef(null);

  const [formData, setFormData] = useState({
    name: ""
  });

  const [formErrors, setFormErrors] = useState({});

  const createMutation = useMutation(apiCreateFolder());
  const editMutation = useMutation(apiUpdateFolder(folder.id));

  useEffect(() => {
    if (show) {
      setFormErrors({});

      setFormData({
        name: folder.name || "",
      });

      nameRef.current.focus();
    }
  }, [show, folder]);

  const updateFormData = field => e => {
    const values = {};

    switch (field) {
      default:
        values[field] = e.target.value;
        break;
    }

    setFormData(prev => ({...prev, ...values}));
  };

  const submit = () => {
    let promise;

    if (mode === MODE_EDIT) {
      promise = editMutation.mutateAsync(formData);
    } else {
      promise = createMutation.mutateAsync(formData);
    }

    return promise
      .then(() => {
        queryClient.invalidateQueries({queryKey: ["memos_folders"]});

        if (mode === MODE_EDIT) {
          showToastSuccess("Dossier modifié");
        } else {
          showToastSuccess("Dossier ajouté");
        }
      })
      .then(hide)
      .catch((err) => {
        if (err.response?.status === 400) {
          setFormErrors(err.response.data.errors);
        }
      });
  };

  return <Editor
    show={show}
    title={mode === MODE_CREATE ? "Ajouter un dossier" : "Modifier un dossier"}
    onSubmit={submit}
    onCancel={hide}
    submitLabel="Sauvegarder"
    cancelLabel="Annuler"
  >
    <Form.Group className="mb-4" controlId="folder-editor-name">
      <Row>
        <Form.Label column sm={3}>Nom</Form.Label>
        <Col sm={9}>
          <Form.Control
            type="text"
            value={formData.name}
            onChange={updateFormData("name")}
            maxLength="255"
            ref={nameRef}
            isInvalid={!!formErrors.name}
          />

          <Form.Control.Feedback type="invalid">{FolderErrors.name[formErrors.name]}</Form.Control.Feedback>
        </Col>
      </Row>
    </Form.Group>
  </Editor>;
};

export default FolderEditor;